import React from 'react';
import '../../assets/styles/Pricing.css';
import '../../assets/styles/SectionBand.css';
import '../../assets/styles/PricingPage.css';
import Footer from '../Footer';
import Pricing0 from '../Pricing/Pricing_0';
import Pricing1 from '../Pricing/Pricing_1';
import Pricing2 from '../Pricing/Pricing_2';

const Pricing = () => {
  return (
    <div className="brand-page-stack pricing-page">
      <Pricing0/>
      <Pricing1/>
      <Pricing2/>
      <Footer/>
    </div>
  );
};

export default Pricing;
